/**
 * How much a watchlist tracks, as counts per kind. Shared by the list page's "Tracking" column
 * and the single page's header status line and aside card headers.
 */

// A filter only counts when it actually narrows something: cleared filters come back as empty
// arrays / strings / nulls depending on which side last wrote them.
const isActiveFilterValue = value => {
  if (value === null || value === undefined || value === '') return false
  if (Array.isArray(value)) return value.length > 0
  if (typeof value === 'object') return Object.keys(value).length > 0
  return true
}

export const countFilters = filters => Object.values(filters ?? {}).filter(isActiveFilterValue).length

export const countTracked = watchlist => {
  const brands = watchlist?.pinnedBrands?.length ?? 0
  const presentations = watchlist?.pinnedPresentations?.length ?? 0
  const filters = countFilters(watchlist?.filters)
  const groups = watchlist?.favGroups?.length ?? 0

  return { brands, presentations, filters, groups, total: brands + presentations + filters + groups }
}
